import angular from 'angular'
import selectDirective from './selectDirective'

export default angular
    .module('app.select', [])
    .directive('eTaxSelect', selectDirective)
    .name



// WEBPACK FOOTER //
// ./src/components/select/index.js